import { useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../config/config.js";
import { makeGetRequestToUrl, makePostRequestToUrl } from "../commonFunc.jsx";
import { useEffect } from "react";
import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, Grid2, IconButton, Paper, Radio, RadioGroup, Snackbar, Switch, TextField, Typography } from "@mui/material";
import TokenError from "../tokenError.jsx";
import AddIcon from '@mui/icons-material/Add';
// import docImg from '../../assets/images/docImg.svg';
import Trash from '../../assets/images/Trash.svg';
import EditPencil from '../../assets/images/EditPencil.svg';
import CloseIcon from '@mui/icons-material/Close';
import uploadBlue from '../../assets/icons/UploadBlue.svg';
import InfoIcon from '@mui/icons-material/Info';
import { Label } from "flowbite-react";
import axios from "axios";

const ParcelSettings = () => {
    const navigate = useNavigate();
    const [tokenExpired, setTokenExpired] = useState(false);
    const [rows, setRows] = useState([]);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [vehicleClient, setVehicleClient] = useState([]); 
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);

    const [openAddModal, setOpenAddModal] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [packageName, setPackageName] = useState('');
    const [packageIcon, setPackageIcon] = useState('');
    const [enableWeight, setEnableWeight] = useState(false);
    const [enableSize, setEnableSize] = useState(false);
    const [weightMandatory, setWeightMandatory] = useState(false);
    const [sizeMandatory, setSizeMandatory] = useState(false);
    const [weightUnits, setWeightUnits] = useState('');
    const [sizeUnits, setSizeUnits] = useState('');
    const [isActive, setIsActive] = useState(false);
    const [parcelId, setParcelId] = useState(0);

    const fetchParcelSettingsData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/settings/fetch_parcel';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setRows(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchParcelSettingsData();
    },[cityFilter])

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
        setEditMode(false);
        setPackageName('');
        setPackageIcon('');
        setEnableWeight(false);
        setEnableSize(false);
        setWeightMandatory(false);
        setSizeMandatory(false);
        setWeightUnits('');
        setSizeUnits('');
        setIsActive(false);
    }

    const handleOpenEditModal = (row) => {
        setOpenAddModal(true);
        setEditMode(true);
        setParcelId(row.id);
        setPackageName(row.name);
        setPackageIcon(row.icon);
        setEnableWeight(row.is_weight_enabled);
        setEnableSize(row.is_size_enabled);
        setWeightMandatory(row.is_weight_mandatory);
        setSizeMandatory(row.is_size_mandatory);
        setWeightUnits(row.weight_unit);
        setSizeUnits(row.size_unit);
        setIsActive(row.is_active);
    }

    const handleClose = () => {
        setOpenAddModal(false);
        setEditMode(false);
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const handleFileChange = async (event) => {
        console.log(event.target.files[0]);
        const file = event.target.files[0];
        if (!file) return;

        // Validate image dimensions (must be between 30-40 px in both width and height)
        const img = new Image();
        const objectUrl = URL.createObjectURL(file);
        try {
            await new Promise((resolve, reject) => {
                img.onload = () => resolve();
                img.onerror = reject;
                img.src = objectUrl;
            });
            console.log('width = ', img.width)
            console.log('height = ', img.height)
            const validW = img.width >= 432 && img.width <= 432;
            const validH = img.height >= 432 && img.height <= 432;
            if (!validW || !validH) {
                setMessage('Please upload an icon with the given size.');
                showSnackbar(true);
                event.target.value = '';
                return;
            }
        } finally {
            URL.revokeObjectURL(objectUrl);
        }

        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await axios.post(operationsUrl + '/upload_image', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            const s3Url = response.data.url;
            setPackageIcon(s3Url);
        } catch (error) {
            console.error('Error uploading image:', error);
        }
    };

    const handleSubmit = async () => {
        const token = localStorage.getItem('token');
        if(!packageName){
            setMessage('Please enter package name.')
            showSnackbar(true);
            return;
        }
        if(enableWeight == 1 && !weightUnits){
            setMessage('Please select weight unit.')
            showSnackbar(true);
            return;
        }
        if(enableSize == 1 && !sizeUnits){
            setMessage('Please select size unit.')
            showSnackbar(true);
            return;
        }
        const payload = {
            token: token,
            name: packageName,
            city_id: cityFilter,
            is_weight_enabled: enableWeight == 1 ? 1 : 0,
            is_size_enabled: enableSize == 1 ? 1 : 0,
            is_weight_mandatory: weightMandatory == 1 ? 1 : 0,
            is_size_mandatory: sizeMandatory == 1 ? 1 : 0,
            is_active: isActive == 1 ? 1 : 0,
        };
        if(packageIcon) payload.icon = packageIcon;
        if(weightUnits) payload.weight_unit = weightUnits;
        if(sizeUnits) payload.size_unit = sizeUnits;

        if (parcelId != 0) {
            payload['id'] = parcelId
        }
        console.log('payload = ', payload)
        try {
            const url = operationsUrl + '/settings/add_update_parcel_type';
            const response = await makePostRequestToUrl(url, payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true); handleClose(); // Close the modal after saving
                fetchParcelSettingsData();
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            setMessage(error);
        }
    }

    const handleAction = async (action, row, value) => {
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            id: row.id
        };
        if(action == 'is_weight_enabled'){
            payload.is_weight_enabled = value ==1 ? 1: 0;
            if(value==0){
                payload.is_weight_mandatory=0;
            }
        } 
        if(action == 'is_size_enabled'){
            payload.is_size_enabled = value ==1 ? 1: 0;
            if(value==0){
                payload.is_size_mandatory=0;
            }
        } 
        if(action == 'is_weight_mandatory'){
            payload.is_weight_mandatory = value ==1 ? 1: 0;
            if(value==1){
                payload.is_weight_enabled = 1;
            }
        } 
        if(action == 'is_size_mandatory'){
            payload.is_size_mandatory = value ==1 ? 1: 0;
            if(value==1){
                payload.is_size_enabled = 1;
            }
        }
        if(action == 'update') payload.is_active = value ==1 ? 1: 0;
        if(action == 'delete') payload.is_active = -1;

        console.log('payload = ', payload)
        try {
            const url = operationsUrl + '/settings/add_update_parcel_type';
            const response = await makePostRequestToUrl(url, payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true); handleClose();
                fetchParcelSettingsData();
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            setMessage(error);
        }
    }

    return (
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Parcel Settings
            </Typography>

            <Grid2 className="mainBox" sx={{border:'1px solid #D1D5DB', marginTop:'12px', borderRadius:'12px', padding:'12px 24px', alignItems:'center'}}>
                <Grid2 item sx={{display:'flex', alignItems:'center'}}>
                    <Grid2 item>
                        <Typography sx={{fontSize:'24px', fontWeight:'500', marginTop:'4px'}}>Package Types</Typography>
                        <Typography sx={{fontSize:'16px', color:'#9FA3A7', marginTop:'4px'}}>Manage available package types that customers can select when creating a delivery</Typography>
                    </Grid2>
                    <Grid2 item sx={{marginLeft:'auto'}}>
                        <Button variant="contained" onClick={handleOpenAddModal}
                         sx={{backgroundColor:'#2A313C', color:'#fff', marginTop:'4px', textTransform:'none', borderRadius:'10px', padding:'12px 24px'}}>
                            <AddIcon sx={{marginRight:'4px'}}/>
                            Add new Package type
                        </Button>
                    </Grid2>
                </Grid2>

                <Grid2 container size={12} spacing={4} sx={{ marginTop:'18px'}}>
                    {rows.map(row => (
                        <Grid2 item size={6} key={row.id} sx={{border:'1px solid #E3E5E8', borderRadius:'12px', padding:'12px'}}>
                        <Grid2 item sx={{display:'flex', alignItems:'center'}}>
                            {(row.icon != '' && row.icon != null) && <img height="40px" width="40px"  src={row.icon} alt="docImg"/>}
                            {/* {(row.icon=='' || row.icon==null) && <img height="40px" width="40px"  src={docImg} alt="docImg"/>} */}
                            
                            <Typography sx={{fontSize:'16px', fontWeight:'400', marginLeft:'4px'}}>{row.name}</Typography>

                            <Grid2 item sx={{marginLeft:'auto', alignItems:'center', display:'flex'}}>
                                <img src={EditPencil} onClick={() => handleOpenEditModal(row)} style={{marginRight:'16px'}} alt="EditPencil"/>
                                <img src={Trash} onClick={() => handleAction('delete', row, -1)} style={{marginRight:'8px'}} alt="Trash"/>
                                <Switch checked={row.is_active} 
                                    onChange={(e) => {
                                        handleAction('update', row, e.target.checked)
                                    }} 
                                    inputProps={{ 'aria-label': 'controlled' }} 
                                />
                            </Grid2>
                        </Grid2>
                        <hr style={{border: 'none', borderTop: '1px solid #E3E5E8'}} />

                        <Grid2 item sx={{border:'1px solid #9CE3C8', backgroundColor:'#F6FCFA', borderRadius:'12px', padding:'6px 12px'}}>
                            <Grid2 item sx={{display:'flex', alignItems:'center'}}>
                                <Typography sx={{fontSize:'16px', color:'#2A313C'}}>Weight setting</Typography>
                                <Switch sx={{marginLeft:'auto', marginRight:'8px'}} checked={row.is_weight_enabled} 
                                    onChange={(e) => {
                                        handleAction('is_weight_enabled', row, e.target.checked)
                                    }}
                                />
                            </Grid2>
                            <Grid2 item sx={{display:'flex', alignItems:'center'}}>
                                    <Grid2 item sx={{border:'1px solid #73D7B1', marginLeft:'8px', borderRadius:'8px', padding:'4px 8px', backgroundColor:'#fff'}}>
                                        {row.weight_unit == 1 && 
                                            <Typography sx={{fontSize:'14px', color:'#098254'}}>kg</Typography>
                                        }

                                        {row.weight_unit == 2 && 
                                            <Typography sx={{fontSize:'14px', color:'#098254'}}>g</Typography>
                                        }
                                        {row.weight_unit == 3 && 
                                            <Typography sx={{fontSize:'14px', color:'#098254'}}>mg</Typography>
                                        }
                                        {row.weight_unit == 4 && 
                                            <Typography sx={{fontSize:'14px', color:'#098254'}}>µg</Typography>
                                        }
                                        {row.weight_unit == 5 && 
                                            <Typography sx={{fontSize:'14px', color:'#098254'}}>t</Typography>
                                        }
                                        {row.weight_unit == 6 && 
                                            <Typography sx={{fontSize:'14px', color:'#098254'}}>lb</Typography>
                                        }
                                        {row.weight_unit == 7 && 
                                            <Typography sx={{fontSize:'14px', color:'#098254'}}>oz</Typography>
                                        }
                                    </Grid2>
                                
                                <Grid2 item sx={{marginLeft:'auto', border:'1px solid #73D7B1', borderRadius:'8px', padding:'0px 8px', backgroundColor:'#fff', display:'flex', alignItems:'center'}}>
                                    <Typography sx={{fontSize:'14px', color:'#098254'}}>Mandatory</Typography>
                                    <Switch checked={row.is_weight_mandatory} 
                                    onChange={(e) => {
                                        handleAction('is_weight_mandatory', row, e.target.checked)
                                    }}/>
                                </Grid2>
                            </Grid2>
                        </Grid2>

                        <Grid2 item sx={{border:'1px solid #FBE3A1', backgroundColor:'#FFFCF6', borderRadius:'12px', padding:'6px 12px', marginTop:'12px'}}>
                            <Grid2 item sx={{display:'flex', alignItems:'center'}}>
                                <Typography sx={{fontSize:'16px', color:'#2A313C'}}>Size setting</Typography>
                                <Switch sx={{marginLeft:'auto', marginRight:'8px'}} checked={row.is_size_enabled} 
                                onChange={(e) => {
                                        handleAction('is_size_enabled', row, e.target.checked)
                                    }}/>
                            </Grid2>
                            <Grid2 item sx={{display:'flex', alignItems:'center'}}>
                                
                                    <Grid2 item sx={{ border:'1px solid #FBE3A1', marginLeft:'8px', borderRadius:'8px', padding:'4px 8px', backgroundColor:'#fff'}}>
                                        {row.size_unit == 1 && 
                                            <Typography sx={{fontSize:'14px', color:'#AC8312'}}>m</Typography>
                                        }
                                        {row.size_unit == 2 && 
                                            <Typography sx={{fontSize:'14px', color:'#AC8312'}}>cm</Typography>
                                        }
                                        {row.size_unit == 3 && 
                                            <Typography sx={{fontSize:'14px', color:'#AC8312'}}>mm</Typography>
                                        }
                                        {row.size_unit == 4 && 
                                            <Typography sx={{fontSize:'14px', color:'#AC8312'}}>μm</Typography>
                                        }
                                        {row.size_unit == 5 && 
                                            <Typography sx={{fontSize:'14px', color:'#AC8312'}}>ft</Typography>
                                        }
                                        {row.size_unit == 6 && 
                                            <Typography sx={{fontSize:'14px', color:'#AC8312'}}>in</Typography>
                                        }
                                    </Grid2>
                                <Grid2 item sx={{marginLeft:'auto', border:'1px solid #FBE3A1', borderRadius:'8px', padding:'0px 8px', backgroundColor:'#fff', display:'flex', alignItems:'center'}}>
                                    <Typography sx={{fontSize:'14px', color:'#AC8312'}}>Mandatory</Typography>
                                    <Switch checked={row.is_size_mandatory} 
                                    onChange={(e) => {
                                        handleAction('is_size_mandatory', row, e.target.checked)
                                    }}/>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                        </Grid2>
                    ))}
                </Grid2>
            </Grid2>

            {openAddModal && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                
                                <Grid2 sx={{ marginBottom: '8px', marginTop: '4px', }}>
                                    <Typography style={{fontWeight: 'bold', fontSize:'18px' }}>
                                        {editMode ? 'Edit Package Type' : 'Add New Package Type'}
                                    </Typography>
                                    {!editMode && (
                                        <Typography sx={{color:'#9FA3A7', fontSize:'14px'}}>
                                            Add a new package type to the list of available options.
                                        </Typography>
                                    )}
                                </Grid2>

                                <Grid2 sx={{marginTop:'2%', border:'1px solid #E3E5E8', borderRadius:'12px', padding:'16px'}}>
                                    
                                    <Grid2 item>
                                        <Label>Name<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'1%'}}
                                            placeholder="Enter Package Name" fullWidth variant="outlined" type="text" value={packageName}
                                            onChange={(e) => setPackageName(e.target.value)}
                                            InputProps={{
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid2>

                                    <Grid2 item sx={{marginTop:'12px'}}>
                                        <Label>Add Package Icon</Label>
                                        <Grid2
                                            sx={{
                                                border: '1px dotted #D1D5DB',
                                                marginTop: '1%',padding: packageIcon ? '2%' : '4%',
                                                borderRadius: '8px',display: 'flex',
                                                alignItems: 'center', gap: '8px'
                                            }}
                                        >
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={handleFileChange}
                                                style={{
                                                display: 'none', // hide the native file input completely
                                                }}
                                                id="upload-button"
                                            />
                                            
                                            <label htmlFor="upload-button" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <img src={uploadBlue} alt="Upload Icon" style={{ width: '24px', height: '24px' }} />
                                                <span style={{ color: '#9FA3A7', fontWeight: 500 }}>Upload Icon</span>
                                                {packageIcon && <img src={packageIcon} alt="" style={{ width: '36px', height: '36px', border:'1px solid #D1D5DB', borderRadius:'8px' }} />}
                                            </label>
                                        </Grid2>
                                        <Grid2 item sx={{backgroundColor:'#FFF1CB', borderRadius:'6px', padding:'4px 8px', marginTop:'8px', alignItems:'center', display:'flex'}}>
                                            <InfoIcon sx={{color:'#2A313C', fontSize:'16px',paddingLeft:'4px'}} />
                                            <Typography sx={{fontSize:'12px', color:'#2A313C', marginLeft:'4px'}}>
                                                Upload a custom icon to override the default icon. Recommended size: 432x432px
                                            </Typography>
                                        </Grid2>
                                    </Grid2>

                                </Grid2>

                                <Grid2 sx={{marginTop:'2%', border:'1px solid #E3E5E8', borderRadius:'12px', padding:'16px'}}>
                                    <Grid2 item sx={{display:'flex', alignItems:'center'}}>
                                        <Grid2>
                                            <Typography sx={{fontSize:'16px', fontWeight:'500', color:'#010101'}}>
                                                Enable Weight Settings
                                            </Typography>
                                            <Typography sx={{fontSize:'14px', color:'#9FA3A7'}}>
                                                Configure weight units and limits for packages
                                            </Typography>
                                        </Grid2>
                                        <Grid2 sx={{marginLeft:'auto'}}>
                                            <Switch
                                                checked={enableWeight}
                                                onChange={(e) => {
                                                    setEnableWeight(e.target.checked)
                                                    if(!e.target.checked) {
                                                        setWeightMandatory(false)
                                                    }
                                                }}
                                            />
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item sx={{border:'1px solid #FBE3A1', borderRadius:'10px', padding:'2px 12px', display:'flex', alignItems:'center', marginTop:'10px', backgroundColor:'rgba(245, 187, 25, 0.04)'}}>
                                        <Grid2>
                                            <Typography sx={{color:'#AC8312', fontSize:'14px'}}>
                                                Make weight mandatory
                                            </Typography>
                                        </Grid2>
                                         <Grid2 sx={{marginLeft:'auto'}}>
                                            <Switch
                                                checked={weightMandatory}
                                                onChange={(e) => {
                                                    setWeightMandatory(e.target.checked)
                                                    if(e.target.checked) {
                                                        setEnableWeight(true);
                                                    }
                                                }}
                                            />
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item sx={{marginTop:'10px'}}>
                                        <Typography sx={{color:'rgba(159, 163, 167, 1)', fontSize:'16px', fontWeight:'500'}}>
                                            Weight Units
                                        </Typography>
                                        <Grid2 item>
                                            <FormControl fullWidth>
                                                <RadioGroup row defaultValue="" sx={{gap:'2%'}}
                                                    value={weightUnits} onChange={(e) => setWeightUnits(e.target.value)}
                                                >
                                                    <FormControlLabel value="1" control={<Radio />} label="kilogram (kg)"/>
                                                    <FormControlLabel value="2" control={<Radio />} label="gram (g)" />
                                                    <FormControlLabel value="3" control={<Radio />} label="milligram (mg)" />
                                                    <FormControlLabel value="4" control={<Radio />} label="microgram (µg)" />
                                                    <FormControlLabel value="5" control={<Radio />} label="tonne (t)" />
                                                    <FormControlLabel value="6" control={<Radio />} label="pound (lb)" />
                                                    <FormControlLabel value="7" control={<Radio />} label="ounce (oz)" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                <Grid2 sx={{marginTop:'2%', border:'1px solid #E3E5E8', borderRadius:'12px', padding:'16px'}}>
                                    <Grid2 item sx={{display:'flex', alignItems:'center'}}>
                                        <Grid2>
                                            <Typography sx={{fontSize:'16px', fontWeight:'500', color:'#010101'}}>
                                                Enable Size Settings
                                            </Typography>
                                            <Typography sx={{fontSize:'14px', color:'#9FA3A7'}}>
                                                Configure size units and limits for packages
                                            </Typography>
                                        </Grid2>
                                        <Grid2 sx={{marginLeft:'auto'}}>
                                            <Switch
                                                checked={enableSize}
                                                onChange={(e) => {
                                                    setEnableSize(e.target.checked)
                                                    if(!e.target.checked) {
                                                        setSizeMandatory(false)
                                                    }
                                                }}
                                            />
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item sx={{border:'1px solid #FBE3A1', borderRadius:'10px', padding:'2px 12px', display:'flex', alignItems:'center', marginTop:'10px', backgroundColor:'rgba(245, 187, 25, 0.04)'}}>
                                        <Grid2>
                                            <Typography sx={{color:'#AC8312', fontSize:'14px'}}>
                                                Make size mandatory
                                            </Typography>
                                        </Grid2>
                                         <Grid2 sx={{marginLeft:'auto'}}>
                                            <Switch
                                                checked={sizeMandatory}
                                                onChange={(e) => {
                                                    setSizeMandatory(e.target.checked)
                                                    if(e.target.checked) {
                                                        setEnableSize(true);
                                                    }
                                                }}
                                            />
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item sx={{marginTop:'10px'}}>
                                        <Typography sx={{color:'rgba(159, 163, 167, 1)', fontSize:'16px', fontWeight:'500'}}>
                                            Size Units
                                        </Typography>
                                        <Grid2 item>
                                            <FormControl fullWidth>
                                                <RadioGroup row defaultValue="" sx={{gap:'2%'}}
                                                    value={sizeUnits} onChange={(e) => setSizeUnits(e.target.value)}
                                                >
                                                    <FormControlLabel value="1" control={<Radio />} label="meter (m)" />
                                                    <FormControlLabel value="2" control={<Radio />} label="centimeter (cm)" />
                                                    <FormControlLabel value="3" control={<Radio />} label="millimeter (mm)" />
                                                    <FormControlLabel value="4" control={<Radio />} label="micrometer (μm)" />
                                                    <FormControlLabel value="5" control={<Radio />} label="foot (ft)" />
                                                    <FormControlLabel value="6" control={<Radio />} label="inch (in)" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom:'40px' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        sx={{width: '140px',height: '50px',textTransform: 'none',
                                            fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                        {editMode ? 'Update' : 'Save'}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleClose}
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            textTransform: 'none',
                                            fontSize: '16px',
                                            backgroundColor: '#F0F0F0',
                                            color: '#B0B0B0',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Paper>

                        </div>
                    </Box>
                </div>
            )}

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
        </div>
    );
};

export default ParcelSettings;